export default "__VITE_ASSET__Brn8Cr$V__"